import { render } from "./Attendancev2View.vue?vue&type=template&id=0f9a4351"
import script from "./Attendancev2View.vue?vue&type=script&lang=js"
export * from "./Attendancev2View.vue?vue&type=script&lang=js"

import "./Attendancev2View.vue?vue&type=style&index=0&id=0f9a4351&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__